import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '../../../services/axiosBaseQuery';

const authApi = createApi({
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Auth'],
  reducerPath: 'authApi',
  endpoints: (build) => ({
    postAuth: build.mutation({
      query: (data) => ({
        url: `/iam/auth/sign`,
        method: 'POST',
        data,
        headers: {
          "Source":"web"
        },
      }),
    }),
    postOtp: build.mutation({
      query: (data) => ({
        url: '/iam/auth/verify',
        method: 'POST',
        data,
        headers: null,
      }),
    }),
    getMe: build.query({
      query: () => ({
        url: '/iam/auth/me',
        method: 'GET',
      }),
      transformResponse: (response) => response.data,
    }),
  }),
});
export const api = {
  usePostAuth: authApi.usePostAuthMutation,
  usePostOtp: authApi.usePostOtpMutation,
  useGetMe: authApi.useGetMeQuery,
};
export default authApi;
